import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a71b8f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 ModelField-colSingle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Реквизит", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-4 ModelField-colSingle" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Общий вес (кг)", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-6 ModelField-colSingle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_CheckBoxControl = _resolveComponent("CheckBoxControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    maxWidth: "600px",
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_CatalogueSelectControl, {
                class: "ModelField-selectControl",
                stylingMode: "outlined",
                id: model.requisiteId,
                "onUpdate:id": ($event: any) => ((model.requisiteId) = $event),
                desc: model.requisiteDescription,
                "onUpdate:desc": ($event: any) => ((model.requisiteDescription) = $event),
                filters: [
                  { column: 'transportTypeDescription', value: 'Контейнер' },
                  { column: 'isActive', value: 'true' },
                ],
                keyField: "id",
                displayDescField: "name",
                catalogueComponentName: "catalogues/RequisiteCatalogue/RequisiteCatalogue",
                hasEmptyValue: false,
                validationGroup: validationGroup,
                onChanged: _ctx.onChange
              }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup", "onChanged"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Общий вес...",
                decimalPoints: 3,
                min: 0,
                value: model.totalWeight,
                "onUpdate:value": ($event: any) => ((model.totalWeight) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_CheckBoxControl, {
                class: "Сheckbox",
                value: model.isActive,
                "onUpdate:value": ($event: any) => ((model.isActive) = $event),
                text: "Активен",
                readOnly: ""
              }, null, 8, ["value", "onUpdate:value"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}